/**
 * Numeric helpers shared across the app.
 */

/**
 * Safe numeric coercion helper for values that are expected to be numeric-ish.
 * - Returns 0 for null/undefined/empty-string or NaN parses.
 * - Preserves finite numbers as-is.
 *
 * Prefer this over direct Number(...) / parseFloat(...) when dealing with
 * loose API data or mixed string/number inputs.
 */
export function toNumber(value: number | string | undefined | null): number {
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : 0;
    }

    if (value === undefined || value === null || value === '') {
        return 0;
    }

    const parsed = Number.parseFloat(String(value));
    return Number.isNaN(parsed) ? 0 : parsed;
}
